import { FvLinkButton, Icon } from '@fv/client-components'
import type { FullShipment } from '@fv/client-types'

import { DividedContent } from '@/components/DividedContent'
import InfoBox from '@/components/InfoBox'
import UploadDocumentField from '@/components/inputs/UploadDocumentField'
import { DetailPanelLayout } from '@/components/list/DetailPanelLayout'

import DocumentList from './DocumentList'

type Props = {
  closePanel: () => void
  load: FullShipment
}

const ListingDocumentsPanel = ({ closePanel, load }: Props) => {
  return (
    <DetailPanelLayout
      header={
        <DividedContent>
          <FvLinkButton onClick={() => closePanel()} icon="arrow-to-left">
            Back
          </FvLinkButton>
          <div>
            <Icon className="text-fv-gray-dark" icon="upload" />
            <span>Upload document</span>
          </div>
        </DividedContent>
      }
      footer={
        <UploadDocumentField
          handleClose={closePanel}
          loadId={load.loadId}
          requireDocType
        />
      }
    >
      <div className="">
        <InfoBox>
          Current documents are shown below. To upload a new document, select
          'Choose file' below.
        </InfoBox>
        <DocumentList
          className="mb-8 flex-1 overflow-auto"
          documents={load.documents}
          loadId={load.loadId}
          canDelete={true}
        />
      </div>
    </DetailPanelLayout>
  )
}

export default ListingDocumentsPanel
